import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ContactSummary, ContractorRecommendedResourcesRequest } from '@jms/model';
import { map, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PortalContactDataService {

  public pickerApi = 'https://__tenant__/api/portal/contractor/picker/';

  constructor(
    private http: HttpClient
  ) { }


  public getRecommendedContractorEmployees(request: ContractorRecommendedResourcesRequest): Observable<ContactSummary[]> {

    return this.http.post<ContactSummary[]>(`${this.pickerApi}contact/recommended`, request)
      .pipe(
        map(x => x),
        catchError(error => {

          return of([]);
        })
      );
  }


}
